import {
  DRIVERS_ACTIONS,
  MORE_ACTIONS_KEYS,
  ROUTES,
  TABLE_NAMES
} from "../../../../../shared";
import AddDriverDialog from "../../dialogs/drivers/AddDriverDialog/AddDriverDialog";
import ExportResourceDialog from "../../dialogs/reusableDialogs/ExportResourceDialog/ExportResourceDialog";
import ImportResourceDialog from "../../dialogs/reusableDialogs/ImportResourceDialog/ImportResourceDialog";
import { useDialog } from "../../hooks/useDialog";
import PageHeaderActions from "../PageHeaderActions";

const DriversHeaderActions = () => {
  const { isDialogOpen, openDialog, closeDialog } = useDialog();

  return (
    <PageHeaderActions
      route={ROUTES.Drivers}
      openDialog={openDialog}
      addItem
      moreActions={[MORE_ACTIONS_KEYS.Import, MORE_ACTIONS_KEYS.Export]}
    >
      <>
        <AddDriverDialog
          isOpen={isDialogOpen[DRIVERS_ACTIONS.AddDriver]}
          onClose={closeDialog}
        />
        <ImportResourceDialog
          tableName={TABLE_NAMES.Drivers}
          isOpen={isDialogOpen[DRIVERS_ACTIONS.ImportDriver]}
          onClose={closeDialog}
          route={ROUTES.Drivers}
        />

        <ExportResourceDialog
          tableName={TABLE_NAMES.Drivers}
          isOpen={isDialogOpen[DRIVERS_ACTIONS.ExportDriver]}
          onClose={closeDialog}
          route={ROUTES.Drivers}
        />
      </>
    </PageHeaderActions>
  );
};

export default DriversHeaderActions;
